import filterProductsByTagId from "../composables/filterProductsByTagId.js";

let carmella_cities = localStorage.getItem("carmella-cities") ? localStorage.getItem("carmella-cities") : [];
let urlParams = new URLSearchParams(window.location.search);

const state = {
    showCartRecoveredNotice: false,
    added: localStorage.getItem("full_cart") ? JSON.parse(localStorage.getItem("full_cart")) : [],
    all: [],
    lastUpdate: "",
    isAdmin: 0,
    tmpUser: false,
    cart: localStorage.getItem("shopping_cart") ? JSON.parse(localStorage.getItem("shopping_cart")) : [],
    products: [],
    search: '',
    searchResultProducts: [],
    categories: [],
    city: localStorage.getItem("city") ? JSON.parse(localStorage.getItem("city")) : "",
    cities: carmella_cities.length ? JSON.parse(carmella_cities) : [],
    permanentproducts: [],
    storedFavs: localStorage.getItem("user_info") ? JSON.parse(localStorage.getItem("user_info")).favoriteProducts : [],
    coupon: "",
    tags: [
        {
            name: "glutenfree",
            id: 18,
        },
        {
            name: "organic",
            id: 19,
        },
    ],
    categoriesProducts: [],
    shipSlots: [],
    page: "",
    sales: "",
    salesproduct: "",
    used_sales: "",
    changeInCart: false,
    orderAs_new: false,
    outOfStockCart: [],
    outOfStock: [],
    sentCart: false,
    sendingCart: false,
    lastProductId: false,
    // allCities: require('../../../cache/israel-cities'),
    allCities: [],
    orderAs:
        localStorage.getItem("carmella-orderas") && localStorage.getItem("carmella-orderas") != "undefined"
            ? JSON.parse(localStorage.getItem("carmella-orderas"))
            : false,
    orderEdit:
        localStorage.getItem("carmella-orderedit") && localStorage.getItem("carmella-orderedit") != "undefined"
            ? JSON.parse(localStorage.getItem("carmella-orderedit"))
            : false,
    showLastProduct: false,
    userLoggedInfo: localStorage.getItem("user_info") ? JSON.parse(localStorage.getItem("user_info")) : "",
    userLogged: localStorage.getItem("user_info") ? true : false,
    formFields: {
		birthday: '',
	},
    showProductPop: false,
    ProductPop: {},
    checkoutStage: "info",
    last_order: "",
    paymentIframe:
        localStorage.getItem("carmella-payform") != "undefined"
            ? JSON.parse(localStorage.getItem("carmella-payform"))
            : "",
    orderEditMeta: localStorage.getItem("carmella-orderEditMeta")
        ? JSON.parse(localStorage.getItem("carmella-orderEditMeta"))
        : "",
    orderIsDonation: false,
    localPickup: wpData.user.city==='איסוף עצמי',
    startProduct: "",
    startCategory: "",
    hasOrderEdit: false,
    cartForGoogle: [],
    permOrder: false,
    permOrderEdit: false,
    permOrderNew: false,
    permenantOrderEdit:
        localStorage.getItem("carmella-PermenantOrderEdit") &&
        localStorage.getItem("carmella-PermenantOrderEdit") != "undefined"
            ? JSON.parse(localStorage.getItem("carmella-PermenantOrderEdit"))
            : false,
    createPermenantOrder: false,
    hideAlert: false,
    permOrderLoaded: false,
    allowPermOrder: wpData.allowPermOrder ? true : false,
    giftCardPurchase: wpData.globalOptions.gift_cards,
    giftCardPurchaseSelectedCards: [],
    giftCardPurchaseGiverName: localStorage.getItem("user_info")
        ? JSON.parse(localStorage.getItem("user_info")).firstname
        : "",
    giftCardForm: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
    },
    giftcard: false,
    checkoutUserExists: false,
    cartTotal: 0,
	productFilters: [
		/*
			Define all product filters here.
			'category_ids' should contain only top-level category ids
		*/
		{
			name: "אורגני", //Name of the filter, also used as display name
			category_ids: [ 16,105,54,30,28,215,367,43,730,65,39 ], // top-level category ids where this filter should be available
			isActive: false,
			fn: products => filterProductsByTagId(products, 19) // function that is ran to filter the products, accepts and returns an array of products
		},
		{
			name: "ללא גלוטן",
			category_ids: [ 54,30,28,215,367,43,730,49,39 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 18)
		},
		{
			name: "טבעוני",
			category_ids: [ 54,30,28,367,43,65,49,39, ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 365),
			image: {
				id: "vegan-friendly-icon",
				src:
					"data:image/png;base64,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",
				alt: ""
			}
		},
		{
			name: "יין אדום",
			category_ids: [ 39 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 115)
		},
		{
			name: "יין לבן",
			category_ids: [ 39 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 114)
		},
		{
			name: "יין רוזה",
			category_ids: [ 39 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 328)
		},
		{
			name: "טרי",
			category_ids: [ 412 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 1903)
		},{
			name: "קפוא",
			category_ids: [ 412 ],
			isActive: false,
			fn: products => filterProductsByTagId(products, 1904)
		},
		{
			name: "במבצע",
			category_ids: "*", // '*' means this filter will be shown on all categories and subcategories
			isActive: false,
			fn: products => products.filter(product => {
				if ( ! product ) return false
				if ( typeof product !== 'object' ) return false
				return product.onsale && product.price
			})
		}
	],
    // inApp: typeof INAPP_USER_DEVICE !== "undefined",
    // inApp: true,
    inApp: urlParams.has('in_app') && urlParams.get('in_app') === 'true',
    weightAndQuantityPopupShown: localStorage.getItem("carmella-weightAndQuantityPopupShown") && localStorage.getItem("carmella-weightAndQuantityPopupShown") !== "undefined",
	// Popoulated in 'components/Checkout/OfficeCoreCoordinates.vue'
    bogoSales: [],
    coordinates: { address: null, x: null, y: null },
    cashback: {
        options: { ...wpData.globalOptions.cashback, ...wpData.globalOptions.cashback_page },
        points: wpData.user.cashback,
        process: {
            pointsTotal: wpData.user.cashback,
            pointsUsed: localStorage.getItem("cashback_points_used") ? localStorage.getItem("cashback_points_used") : 0
        }
    },
    sendingCartToRecipeBot: false,
    emergencyMode: wpData.emergency_mode,
    productsView: localStorage.getItem("products_view") ? localStorage.getItem("products_view") : 'grid',
};

export default state;
